import styled from 'styled-components';
import { HeaderWrapper as UnstyledHeaderWrapper } from '../../../../layouts/Header/styles';

export const HeaderWrapper = styled(UnstyledHeaderWrapper)`
  background-image: none;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #ffffff;
  height: 84px;
  border-bottom: 1px solid #A7A7A7;

  img {
    max-width: 100%;
    object-fit: contain;
    height: 48px;
    width: 48px;
  }

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
  }
`;

export const LanguageWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;

  .language-selector {
    display: flex;
    align-items: center;
    background: #F1F5F7;
    padding: 8px;
    border-radius: 8px;
    height: 54px;
    width: 82px;

    div {
      cursor: pointer;
      padding: 8px;
      user-select: none;
      font-size: 14px;
      color: #212121;
      border-radius: 4px;
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 600;
      height: 36px;
      width: 33px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: #e5e7eb;
      }

      &.active {
        background-color: #ffffff;
        border-color: #ffffff;
      }
    }
  }
`;
